export const AMPLITUDE_LIBRARY_EVENTS = Object.freeze({
  SESSION_PREVIEW: 'preview session',
  ADD_TO_FAVORITES: 'add to favorites',
  BOOK_BUTTON: 'book button',
  CONFIRM_BOOK_BUTTON: 'confirm book button',
  ADD_SESSION_TO_CART: 'add session to cart',
  REMOVE_SESSION_FROM_CART: 'remove session from cart',
  CLICK_BOOK_SESSION: 'click book session',
  CLICKED_VIEW_WEEKLY_OOO: 'click view weekly 1-1s',
});

export const AMPLITUDE_BOOKING_CART_EVENTS = Object.freeze({
  CLEAR_CART: 'clear cart',
  VIEW_CART: 'view cart',
  CLICK_ASSIGN_MATERIALS: 'click assign materials',
  CLICK_CONFIRM_BOOKING: 'click confirm booking',
  COMPLETE_BOOKING: 'complete booking',
});

export const AMPLITUDE_BUNDLE_EVENTS = Object.freeze({
  BUNDLE_PREVIEW: 'preview bundle',
  BOOK_BUNDLE_BUTTON: 'book bundle button',
  BOOK_BUNDLE_STEP_2: 'book bundle step 2',
  CONFIRM_BOOK_BUTTON: 'confirm book bundle',
  ADD_BUNDLE_TO_CART: 'add bundle to cart',
  REMOVE_BUNDLE_FROM_CART: 'remove bundle from cart',
});

export const AMPLITUDE_SCHOOL_CLASS_EVENTS = Object.freeze({
  CLICKED_MANUAL_IMPORT_CLASS: 'click create new classes',
  CLICKED_MANUAL_STEP1_NEXT: 'complete class creation step 1',
  CLICKED_MANUAL_STEP2_CREATE_CLASSES: 'complete class creation step 2',
  CREATED_CLASS: 'create class',
  UPLOADED_CLASS_ROSTER_CSV: 'upload class roster csv',
  ADDED_STUDENTS: 'add students to class',
  EDITED_STUDENTS: 'edit student',
  REMOVED_STUDENT: 'remove student',
  UPDATED_CLASS_LEVEL: 'update class level',
  UPDATED_CLASS_TOPIC: 'update class topic',
  PREVIEWED_CLASS_PLANNER: 'preview class planner',
  UPDATED_CLASS_PLANNER: 'update class planner',
  CLICKED_CLASS_CARD: 'click class card',
  CLICKED_CLASS_CARD_EDIT_CLASS_SETTINGS: 'click class card edit class settings',
  CLICKED_CLASS_CARD_SET_WEEKLY_GOAL: 'click class card set weekly goal',
  CLICKED_CLASS_CARD_MANAGE_CLASS_ROSTER: 'click class card manage class roster',
  CLICKED_CLASS_CARD_CONNECT_WITH_GOOGLE_CLASSROOM:
    'click class card connect with google classroom',
  CLICKED_CLASS_CARD_UNLINK_FROM_GOOGLE_CLASSROOM: 'click class card unlink from google classroom',
  SHOWED_ARCHIVED_CLASSES: 'show archived classes',
  CLICKED_SESSION_CARD: 'click on the session card',
  CLICKED_MANAGE_CLASS_BUTTON: 'click manage class button',
  CLICKED_AGGREGATE_PERFORMANCE: 'click aggregate performance button',
  CLICKED_ASSESSMENTS_BUTTON: 'click assessments button',
  CLICKED_CLASS_ENGAGEMENT: 'click class engagement report button',
  CLICKED_CLASS_RESULTS: 'click class results report button',
  CLICKED_CLASS_OVERVIEW: 'click class overview report button',
  CLICKED_CLASS_GOALS_DASHBOARD: 'click class goals dashboard button',
  CLICKED_WEEKLY_1_1_CARD: 'click weekly 1-1 card',
  CLICKED_WEEKLY_CLASS_GOAL: 'click weekly class goal',
  VIEWED_CLASS_PAGE: 'view class page',
  CLICKED_PLANNER_TAB: 'click planner tab',
  CLICKED_ACTIVE_TAB: 'click active tab',
  CLICKED_SCHEDULED_TAB: 'click scheduled tab',
  CLICKED_DONE_TAB: 'click done tab',
  CLICKED_WITH_PRACTICE_BUDDY_TAB: 'click with practice buddy tab',
  CLICKED_SELF_STUDY_TAB: 'click self study tab',
  CLICKED_RECOMMENDED_BUNDLES_CARD: 'click recommended bundles card',
  CLICKED_RECOMMENDED_BUNDLES_TAB: 'click recommended bundles tab',
  CLICKED_CREATE_GROUP: 'click create group',
  CREATED_GROUP: 'create group',
  CLICKED_CLASS_BOOKING_TAB_EMPTY_STATE_PRIMARY_CTA:
    'click class booking tab empty state primary CTA',
  CLICKED_CLASS_BOOKING_TAB_EMPTY_STATE_SECONDARY_CTA:
    'click class booking tab empty state secondary CTA',
  CLICKED_SETUP_WEEKLY_SCHEDULE: 'click set up a weekly schedule',
  CLICKED_BOOK_A_SESSION: 'click book a session',
  CLICKED_REPORTS_BUTTON: 'click reports button',
  SWITCHED_VIEW: 'switch view',
  CLICKED_LEARNING_SCHEDULE_BUTTON: 'click learning schedule button',
  CLICKED_VIEW_GROUPS_BUTTON: 'click view groups button',
  VIEWED_GROUPS_PAGE: 'view groups page',
  CLICKED_EDIT_GROUP_BUTTON: 'click edit group button',
  CLICKED_DELETE_GROUP_BUTTON: 'click delete group button',
  CLICKED_REMOVE_STUDENT_FROM_GROUP: 'click remove student from group',
  EDITED_GROUP: 'edit group',
  DELETED_GROUP: 'delete group',
  REMOVED_STUDENT_FROM_GROUP: 'remove student from group',
  VIEWED_SESSION_DETAILS_PAGE: 'view session details page',
  CLICKED_STUDENT_NAME: 'click student name',
  VIEWED_CLASS_OVERVIEW_REPORT: 'view class overview report',
  VIEWED_CLASS_ENGAGEMENT_REPORT: 'view class engagement report',
  VIEWED_CLASS_RESULTS_REPORT: 'view class results report',
  EXPORTED_CLASS_RESULTS_REPORT_TO_CSV: 'export class results report to CSV',
});

export const AMPLITUDE_STUDENT_PROFILE_EVENTS = Object.freeze({
  VIEWED_STUDENT_PROGRESS_REPORT: 'view student progress report',
  RATED_CLASS_ENGAGEMENT: 'rate class engagement',
  RATED_AVG_PERFORMANCE_PER_FOCUS: 'rate avg performance per focus',
  SEND_FEEDBACK_TO_STUDENT: 'send feedback to student',
});

export const AMPLITUDE_GOOGLE_CLASSROOM_EVENTS = Object.freeze({
  AUTHORIZED_GOOGLE_ACCOUNT: 'authorize google account',
  CLICKED_SHARE_BOOKING: 'share to google classroom',
  CONNECTED_COURSE: 'match gc course and mo class',
  CREATED_ASSIGNMENT: 'create google classroom assignment',
  CLICKED_IMPORT_CLASSES_FROM_GC: 'click import classes from gc',
  CLICKED_IMPORT_CLASSES: 'click import classes',
  GOT_GC_DATA: 'get gc data',
  POSTED_LOGIN_LINK: 'post login link to google classroom',
});

export const AMPLITUDE_SESSION_DETAILS_EVENTS = Object.freeze({
  CLICK_LIVE_REPORT_SHOW_MORE: 'click live report show more',
  CLICK_LIVE_REPORT_SHOW_LESS: 'click live report show less',
});

export const AMPLITUDE_CONTENT_EDITING_EVENTS = Object.freeze({
  VIEW_MY_EXERCISES_PAGE: 'view my exercises page',
  CLICK_EDIT_CHALLENGE: 'click edit challenge',
  CLICK_EDIT_CHALLENGE_QUESTION: 'click edit challenge question',
  EDIT_CHALLENGE_QUESTION: 'edit challenge question',
  CUSTOMIZE_CHALLENGE: 'customize challenge',
  REQUEST_CHALLENGE_QUESTION_EDIT: 'request challenge question edit',
});

export const ERROR_EVENTS = Object.freeze({
  VIEW_ERROR_NOTIFICATION: 'view error notification',
});
